import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';

export const transformFieldName = key => {
    const constants = {
        basicCharge: I18n.get('LABEL-BASIC-CHARGE'),
        numOfGeneralUser: I18n.get('CM-TEXTBOX-GENERAL-USER-NUMBER'),
        numOfTicket: I18n.get('CM-TEXTBOX-ADDITIONAL-TICKET-SET'),
        numOfTicketKnowledge: I18n.get('CM-TEXTBOX-ADDITIONAL-KNOWLEDGE-SET'),
        numOfStorage: I18n.get('CM-TEXTBOX-ADDITIONAL-STORAGE-SET'),
        numberOfQACounters: I18n.get('CM-TEXTBOX-ADDITIONAL-Q&A-COUNTER-SET'),
        numberOfSupportedCounters: I18n.get('CM-TEXTBOX-ADDITIONAL-SUPPORT-COUNTER-SET'),
    };

    const foundEntry = Object.entries(constants).find(([k, v]) => k === key);
    if (foundEntry) {
        return foundEntry[1];
    } else {
        return '';
    }
};

export const filterUnitLabel = key => {
    if (key === 'basicCharge') return '';
    if (key === 'numOfGeneralUser') return I18n.get('LABEL-ID');

    return I18n.get('LABEL-UNIT-SET');
};

const calcQuantityUpdateOfAdvancedSetting = (
    generalUpdate,
    quantityUseByAPerson,
    quantityCustomByRoot,
    numberOfUpdate,
    quantityOfASetInVersion
) => {
    console.log({generalUpdate,
        quantityUseByAPerson,
        quantityCustomByRoot,
        numberOfUpdate,
        quantityOfASetInVersion})
    return (
        generalUpdate * (quantityUseByAPerson + quantityCustomByRoot) +
        numberOfUpdate * quantityOfASetInVersion
    );
};

const getDataField = (versionData, updateData, additionalPrivateSetting) => {
    return [
        {
            kind: 'numOfTicket',
            data: {
                quantityUseByAPerson: Number(versionData.numberOfTickets),
                quantityCustomByRoot: Number(additionalPrivateSetting?.numOfTicket) || 0,
                numberOfUpdate: Number(updateData.numOfTicket.quantity.update) || 0,
                quantityOfASetInVersion: Number(versionData.numberOfAdditionalTickets.value) || 0
            }
        },
        {
            kind: 'numOfTicketKnowledge',
            data: {
                quantityUseByAPerson: Number(versionData.numberOfKnowledges) || 0,
                quantityCustomByRoot: Number(additionalPrivateSetting?.numberOfKnowledges) || 0,
                numberOfUpdate: Number(updateData.numOfTicketKnowledge.quantity.update) || 0,
                quantityOfASetInVersion: Number(versionData.numberOfAdditionalKnowledge.value) || 0
            }
        },
        {
            kind: 'numOfStorage',
            data: {
                quantityUseByAPerson: parseFloat(versionData.storageVolume),
                quantityCustomByRoot: Number(additionalPrivateSetting?.numOfStorage) || 0,
                numberOfUpdate: parseFloat(updateData.numOfStorage.quantity.update) || 0,
                quantityOfASetInVersion: Number(versionData.numberOfAdditionalStorages.value) || 0
            }
        },
        {
            kind: 'numberOfQACounters',
            data: {
                quantityUseByAPerson: Number(versionData.numberOfQACounters) || 0,
                quantityCustomByRoot: Number(additionalPrivateSetting?.numOfQACounters) || 0,
                numberOfUpdate: Number(updateData.numberOfQACounters.quantity.update) || 0,
                quantityOfASetInVersion: Number(versionData.numberOfAdditionalQACounter.value) || 0
            }
        },
        {
            kind: 'numberOfSupportedCounters',
            data: {
                quantityUseByAPerson: Number(versionData.numberOfSupportedCounters) || 0,
                quantityCustomByRoot: Number(additionalPrivateSetting?.numOfSupportedCounters) || 0,
                numberOfUpdate: Number(updateData.numberOfSupportedCounters.quantity.update ) || 0,
                quantityOfASetInVersion: Number(versionData.numberOfAdditionalSupportedCounter.value) || 0
            }
        }
    ];
};

export const hanldeValidateInputSubmit = (contractDetail, updateContractData) => {
    const versionData = contractDetail.versionData.moduleSetting;
    const corpData = contractDetail.corporationData.limitValue;
    const additionalPrivateSetting = contractDetail.contractDetail.additionalPrivateSetting;

    const dataField = getDataField(versionData, updateContractData.advanceSetting, additionalPrivateSetting);
    const generalUpdate = Number(updateContractData.basicSetting.numOfGeneralUser.quantity.update);
    let resultValid = cloneDeep(updateContractData);
    let isValid = false;
    if (generalUpdate < corpData.numOfGeneralUser) {
        resultValid.basicSetting.numOfGeneralUser = {
            ...resultValid.basicSetting.numOfGeneralUser,
            error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
        };
        isValid = true;
    }

    dataField.map(item => {
        switch (item.kind) {
            case 'numOfTicket':
                const numTicketUpdate = calcQuantityUpdateOfAdvancedSetting(
                    generalUpdate,
                    item.data.quantityUseByAPerson,
                    item.data.quantityCustomByRoot,
                    item.data.numberOfUpdate,
                    item.data.quantityOfASetInVersion
                );
                if (numTicketUpdate < corpData.numOfTicket) {
                    resultValid.advanceSetting.numOfTicket = {
                        ...resultValid.advanceSetting.numOfTicket,
                        error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
                    };
                    isValid = true;
                }
                break;
            case 'numOfTicketKnowledge':
                const numTicketKnowledgeUpdate = calcQuantityUpdateOfAdvancedSetting(
                    generalUpdate,
                    item.data.quantityUseByAPerson,
                    item.data.quantityCustomByRoot,
                    item.data.numberOfUpdate,
                    item.data.quantityOfASetInVersion
                );
                console.log({numTicketKnowledgeUpdate, numOfTicketKnowledge: corpData.numOfTicketKnowledge })

                if (numTicketKnowledgeUpdate < corpData.numOfTicketKnowledge) {
                    resultValid.advanceSetting.numOfTicketKnowledge = {
                        ...resultValid.advanceSetting.numOfTicketKnowledge,
                        error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
                    };
                    isValid = true;
                }
                break;
            case 'numOfStorage':
                const numStorageUpdate = calcQuantityUpdateOfAdvancedSetting(
                    generalUpdate,
                    item.data.quantityUseByAPerson,
                    item.data.quantityCustomByRoot,
                    item.data.numberOfUpdate,
                    item.data.quantityOfASetInVersion
                );
                let usedStorage = Utils.convertByteToGigaByte(corpData.numOfStorage, 6) || 0;
                if (numStorageUpdate < parseFloat(Number(usedStorage).toFixed(3))) {
                    resultValid.advanceSetting.numOfStorage = {
                        ...resultValid.advanceSetting.numOfStorage,
                        error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
                    };
                    isValid = true;
                }
                break;
            case 'numberOfQACounters':
                const numQACountersUpdate = calcQuantityUpdateOfAdvancedSetting(
                    generalUpdate,
                    item.data.quantityUseByAPerson,
                    item.data.quantityCustomByRoot,
                    item.data.numberOfUpdate,
                    item.data.quantityOfASetInVersion
                );
                if (numQACountersUpdate < corpData.numberOfQACounters) {
                    resultValid.advanceSetting.numberOfQACounters = {
                        ...resultValid.advanceSetting.numberOfQACounters,
                        error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
                    };
                    isValid = true;
                }
                break;
            case 'numberOfSupportedCounters':
                const numSupportedCountersUpdate = calcQuantityUpdateOfAdvancedSetting(
                    generalUpdate,
                    item.data.quantityUseByAPerson,
                    item.data.quantityCustomByRoot,
                    item.data.numberOfUpdate,
                    item.data.quantityOfASetInVersion
                );
                if (numSupportedCountersUpdate < corpData.numberOfSupportedCounters) {
                    resultValid.advanceSetting.numberOfSupportedCounters = {
                        ...resultValid.advanceSetting.numberOfSupportedCounters,
                        error: I18n.get('MSG-CONTRACT-UPDATE-WRONG')
                    };
                    isValid = true;
                }
                break;
            default:
                break;
        }
    });
    return {isValid, resultValid};
};
